import React, { Component } from 'react'
import Dashresults from './Dashresults'
import '../stylesheets/components/dashresults.scss'

class Dashresultslist extends Component{

	constructor(props){
		super(props)
		this.state = {
			dashboards: []
		}
	}

	componentWillMount(){
		fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/dashboards')
	      .then(response => response.json())
	      .then(data => this.setState({ dashboards: data }));
	}

	render(){

		const dashSection = this.state.dashboards.map((dashboard, key) => {
		    return (
		        <Dashresults 
		          	number={dashboard.value}
		          	numberComplement=""
		          	text={dashboard.title}
		          	text2={dashboard.support}
		          	key={key}
		          />
		    );
		});

		return (
			<section className="o-dashresults">
				<div className="o-container" >
					<p className="c-title c-title--size-small c-title--weight-bold c-title--color-white c-title--align-center o-uppercase">
			            O Serasa Itinerante até agora:
			            <br />
			        </p>
			        
					<ul className="o-list o-list--display o-list--display-inline o-list--align o-list--align-center ">
						{dashSection}
		        	</ul>
				</div>
			</section>
		)
	}

}

export default Dashresultslist


// WEBPACK FOOTER //
// ./src/components/Dashresultslist.js